import React from 'react'

function Map() {
  return (
    <section className="ttm-row conatact-section clearfix">
  <div className="container">
    {/* row */}
    <div className="row">
      <div className="col-xl-5">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.073142653587!2d74.43953640000001!3d31.522150999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190f24aaea6609%3A0x298e52b98aa0454c!2sNask%20International!5e0!3m2!1sen!2s!4v1739356148112!5m2!1sen!2s" width="100%" height={558} />
      </div>
      <div className="col-xl-7">
        <div className="padding_left15 res-1199-padding_left0 padding_top20 res-1199-padding_top40">
          {/* section title */}
          <div className="section-title">
            <div className="title-header">
              <h3>CONTACT US</h3>
              <h2 className="title">Get In <b>Touch!</b></h2>
            </div>
            <div className="title-desc">
              <p>Nask International operates in the textile market as a manufacturer and trader. Over the years, the range of textile products produced has expanded.</p>
            </div>
          </div>{/* section title end */}
          <h2 className="fs-24 padding_top10">Head Office</h2>
          <div className="ttm-horizontal_sep width-100 margin_top20 margin_bottom5" />
          <div className="row">
            <div className="col-lg-6 col-md-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-before-content">
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-color-grey ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i className="themifyicon ti-location-pin ttm-textcolor-skincolor" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3 className="margin_bottom0 fs-18">Address</h3>
                  </div>
                  <div className="featured-desc">Office # 2, 3rd Floor, 21-CCA, DHA 8 (Ex-Park View), Block D Cantt, Lahore, Pakistan</div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-6 col-md-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-before-content">
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-color-grey ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i className="themifyicon ti-email ttm-textcolor-skincolor" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3 className="margin_bottom0 fs-18">Call Us / Email</h3>
                  </div>
                  <div className="featured-desc">
                    +92 305 1115508<br />sales@naskinternational.com</div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
          </div>
        </div>
      </div>
    </div>{/* row end */}
  </div>
</section>

  )
}

export default Map